import { CSSProperties, forwardRef, useMemo } from 'react'

import classNames from 'classnames'

import { alignClasses, BoxProps, gapClasses, justifyClasses } from './types'

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      className,
      children,
      col,
      center,
      alignCenter,
      justifyCenter,
      align,
      justify,
      row,
      flex,
      gap,
      style,
      ...rest
    },
    ref,
  ) => {
    const styles = useMemo(
      () => ({ ...(style || {}), flex } as CSSProperties),
      [flex, style],
    )

    return (
      <div
        {...rest}
        ref={ref}
        style={styles}
        className={classNames(
          'flex',
          {
            'flex-col': col,
            'flex-row': row,
            'items-center': alignCenter || center,
            'justify-center': justifyCenter || center,
          },
          align && alignClasses[align],
          justify && justifyClasses[justify],
          gap && gapClasses[gap],
          className,
        )}
      >
        {children}
      </div>
    )
  },
)
